const WEB_APP_URL = (
  import.meta.env.VITE_WEB_APP_URL as string | undefined
)?.replace(/\/$/, '')

function appOriginFromChatOrigin(origin: string): string | null {
  try {
    const url = new URL(origin)
    if (!url.hostname.startsWith('chat')) return null
    url.hostname = url.hostname.replace(/^chat/, 'app')
    url.pathname = ''
    url.search = ''
    url.hash = ''
    return url.toString().replace(/\/$/, '')
  } catch {
    return null
  }
}

export function webBaseUrl(): string {
  if (WEB_APP_URL) {
    return appOriginFromChatOrigin(WEB_APP_URL) ?? WEB_APP_URL
  }

  const { origin, protocol, hostname } = window.location
  if (hostname.startsWith('chat')) {
    return (
      appOriginFromChatOrigin(origin) ??
      `${protocol}//${hostname.replace(/^chat/, 'app')}`
    )
  }
  if (
    import.meta.env.DEV &&
    (hostname === 'localhost' || hostname === '127.0.0.1')
  ) {
    return 'http://localhost:4040'
  }
  return window.location.origin
}

export function webUrl(path: string): string {
  return `${webBaseUrl()}${path}`
}

export function redirectToWebPath(path: string): void {
  const target = webUrl(path)
  if (target !== window.location.href) {
    window.location.replace(target)
  }
}
